module.exports = __webpack_public_path__ + "static/media/profilepictureSlim.f20267b6.jpg";